import config from '@/config/config';

import Index from '@/pages/config/company-type/index.vue';
import List from '@/pages/config/company-type/list/list.vue';
import View from '@/pages/config/company-type/view/view.vue';
import New from '@/pages/config/company-type/new/new.vue';
import Edit from '@/pages/config/company-type/edit/edit.vue';

const modulePermission = config.modules.companyType;

export default {
  path: '/company-type',
  name: 'company-type',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'company-type-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'company-type-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'company-type-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'company-type-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
